import ThemeService from './ThemeService';
export default new ThemeService();
